import { Box, Stack, Typography, useTheme } from "@mui/material";
import { type Control, useController } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import {
	PORTFOLIO_SORT,
	type PortfolioSortKey,
} from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioSortKey";
import { SortDirectionToggle } from "web_myplann/Portfolio/Components/Redesign/Filter/SortDirectionToggle";
import { FlatRowFormRadio } from "web_myplann/Shared/Components/FlatRow/FlatRowFormRadio";

const SORT_OPTIONS: PortfolioSortKey[] = [
	PORTFOLIO_SORT.oblast,
	PORTFOLIO_SORT.name,
	PORTFOLIO_SORT.value,
	PORTFOLIO_SORT.producer,
];

type Props = {
	control: Control<FilterFormValues>;
};

export const SortFilterSection = ({ control }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	const sortDescField = useController({ control, name: "sortDesc" });

	return (
		<>
			<Typography variant="sectionLabel">
				{t(Resources.Portfolio.List.Redesign.Filter.sortLabel)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<FlatRowFormRadio
					control={control}
					name="sort"
					options={SORT_OPTIONS.map((option) => ({
						value: option,
						label: t(Resources.Portfolio.List.Redesign.Sort[option]),
					}))}
				/>
			</Stack>

			<Box px={theme.spacingTokens.lg} pt={theme.spacingTokens.lg}>
				<SortDirectionToggle
					value={sortDescField.field.value}
					onChange={sortDescField.field.onChange}
				/>
			</Box>
		</>
	);
};
